import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';

import TaxReceiptCampaignSettingsPanel from './TaxReceiptCampaignSettingsPanelContainer';

class TaxReceiptCampaignSettingsTabRoute extends Component {

  render() {
    const { locale, campaignId } = this.props;
    const path = `/${locale}/d/campaigns/${campaignId}/settings/transactions/donationreceipt`;

    return (
      <Route exact path={path} render={(props) => <TaxReceiptCampaignSettingsPanel {...this.props} />} />
    );
  }

}

TaxReceiptCampaignSettingsTabRoute.propTypes = {
  locale: PropTypes.string.isRequired,
  campaignId: PropTypes.number.isRequired,
};

export default TaxReceiptCampaignSettingsTabRoute;
